<template>
	<div class="Audition">
		<div v-if="daysLeftForRegistration >= 0">
			<div v-if="!adminContext" class="end-of-time">
				<label class="end-of-time-days">
					{{daysLeftForRegistration}} יום
				</label>
				<p>למועד סגירת ההרשמה, הבטיחו את מקומכם עכשיו!</p>
			</div>
			<p v-if="!adminContext" v-html="texts.audition_text1"></p>
				<div class="auditionSiteMessage" v-if="site === null" >
					<label class="auditionDateLabel"><b>{{auditionCurrentDate}}</b></label>
				</div>
			<div class="auditionTab" :class="{auditionTabActive : site === 'north' }" v-on:click="chooseNorth()">צפון (חיפה)</div><div class="auditionTab" :class="{auditionTabActive : site === 'center' }" v-on:click="chooseCenter()">מרכז (תל אביב)</div>
			<div class="auditionBlock">
				<div class="auditionDate" v-if="auditionsDays[0].day != ''" >
					<div class="auditionNextDate" :class="{buttonHidden : pickedDay > auditionsDays.length-2 }" v-on:click="nextDay()"><img alt="הבא" src="images/arrow-next.png"/></div>
					<label class="auditionDateLabel">{{auditionCurrentDate}}</label>
					<div class="auditionPrevDate" :class="{buttonHidden : pickedDay <= 0 }" v-on:click="prevDay()"><img alt="הקודם" src="images/arrow-prev.png"/></div>
				</div>
				<div class="auditionSlots">
					<div class="fullAuditionMessage" v-if="site == null">
						<mark class="auditionSlotLabel">מועדי האודישנים הפנויים יוצגו לאחר בחירת הסניף</mark>
					</div>
					<div class="fullAuditionMessage" v-if="site != null && auditionsDays[0].day === ''">
					<br>
						<mark class="auditionSlotLabel">אין מועדים פנויים לאודישן</mark>
					</div>

					<div class="auditionSlot" :class="{auditionPicked : pickedTimeSlot === audition , auditionTaken : !audition.open}" v-for="audition in auditionsDays[pickedDay].data" v-on:click="pickaudition(audition)">
						<label class="auditionSlotLabel">{{audition.hour}}</label>
					</div>
					<div class="fullAuditionMessage" v-if="site != null && auditionsDaysComplete[pickedDay]">
						<mark class="auditionSlotLabel">יום אודישנים מלא!</mark><br>
						<mark class="auditionSlotLabel">לחצו על החץ כדי לעבור למועד הבא</mark>
					</div>
				</div>

				<label class="audition-next-button" :class="{nextButtonDisabled : Object.keys(pickedTimeSlot).length === 0 && pickedTimeSlot.constructor === Object }" v-on:click="moveToLogin()">
					הבא
				</label>
			</div>
			<p v-if="!adminContext" v-html="texts.audition_text2"></p>
			<Login :userId='userId' :adminContext='adminContext' :pickedTimeSlot='pickedTimeSlot' :auditionType='auditionType' :branchInput='site' v-if="showLogin" @close="showLogin = false"></Login>
		</div>
		<div class="Audition" v-else>
			<div v-if="!adminContext">
				<div class="end-of-time">
				<p v-html="texts.audition_text3"></p>
				</div>
				<TalkToMeNoModal :auditionType='auditionType'></TalkToMeNoModal>
			</div>
			<div v-else>
				אין מועדים פנויים לאודישן
			</div>
		</div>
	</div>
</template>

<script>
 import Login from '../components/Login.vue'
  import TalkToMeNoModal from '../components/TalkToMeNoModal.vue'
  import axios from 'axios'
  var APIbase = "https://yard-bands.herokuapp.com"
  export default {
    components: {
      Login,TalkToMeNoModal
    },
	props: ['auditionType'],
	created () {
		this.adminContext = window.location.href.includes("admin");
		console.log(this.auditionType)
		this.fetchAuditions();
		this.texts = {}
		this.fetchAuditionLabels();
	},
	data() {
		return {
			timeTillEnd: "10",
			auditionCurrentDate : "נא לבחור סניף",
			auditionsDaysComplete: [true],
			totalAuditions: {},
			auditionsDays: [{day:'',data:[]}],
			pickedDay:0,
			pickedTimeSlot: {},
			userId: "",
			site: null,
			showLogin : false
		}
	},
	computed: {
		daysLeftForRegistration : function () {
			let maxDate = null;

			for (let site in this.totalAuditions) {
				this.totalAuditions[site].forEach(entry => {
					
					let parts = entry.day.split('/'); // Split "13/08/25"
					let currentDate = new Date(`20${parts[2]}-${parts[1]}-${parts[0]}`); // Convert to YYYY-MM-DD

					if (!maxDate || currentDate > maxDate) {
						maxDate = currentDate;
					}
				});
			}
			
    		if (maxDate != null) {				
				var dayToSplit = maxDate.toLocaleDateString("en-GB").split("/");
				console.log(dayToSplit);
				return this.days_between(new Date(dayToSplit[2]+"-"+dayToSplit[1]+"-"+dayToSplit[0]),new Date())
			}
		}
	},
	watch: {
		showLogin: function (val) {
			if (val) {
				document.body.classList.add('modal-open');
				document.getElementById("headerC").classList.add('background-modal');
				document.getElementById("FAQS").classList.add('background-modal');
				document.getElementById("FAQSdivider").classList.add('background-modal');
        document.getElementById("FAQS").classList.add('background-modal');
        document.getElementById("footerC").classList.add('background-modal');
			}
			else {
			axios.post(APIbase+'/v2/cancel_deebs_audition',{
									hour: this.pickedTimeSlot.hour,
									day: this.pickedTimeSlot.day,
									site: this.site
								}).then(response => {
						document.body.classList.remove('modal-open');
						document.getElementById("headerC").classList.remove('background-modal');
						document.getElementById("content-wrapper").classList.remove('background-modal-wrapper');
						document.getElementById("FAQSdivider").classList.remove('background-modal');
						document.getElementById("FAQS").classList.remove('background-modal');
						document.getElementById("footerC").classList.remove('background-modal');
				})
			}
		}
	},

	methods: {
		fetchAuditionLabels() {
			axios.get(APIbase+'/audition_text').then(response => {
				this.texts = response.data;
				this.$forceUpdate();
			})
		},
		days_between(date1, date2) {

			// The number of milliseconds in one day
			var ONE_DAY = 1000 * 60 * 60 * 24

			// Convert both dates to milliseconds
			var date1_ms = date1.getTime()
			var date2_ms = date2.getTime()

			// Calculate the difference in milliseconds
			var difference_ms = Math.abs(date1_ms - date2_ms)

			// Convert back to days and return
			return Math.round(difference_ms/ONE_DAY)

		},
		fetchAuditions () {
			axios.get(APIbase+'/v2/auditions/').then(response => {
       			// Process each site's auditions
				let processed = {};
				for (let site in response.data) {
					// Filter and sort auditions for each site
					processed[site] = response.data[site]
						// Filter out days with no open slots
						//.filter(day => day.data && day.data.some(slot => slot.open))
						// Sort by date
						.sort((a, b) => {
							let [dayA, monthA, yearA] = a.day.split('/');
							let [dayB, monthB, yearB] = b.day.split('/');
							return new Date(`20${yearA}`, monthA-1, dayA) - new Date(`20${yearB}`, monthB-1, dayB);
						});
				}
				this.totalAuditions = processed;

				if (this.site) {
					this.auditionsDays = this.totalAuditions[this.site] || [{day:'',data:[]}];
					this.auditionsDaysComplete = this.auditionsDays.map(n => 
						n.data && n.data.some(c => c.open) ? false : true
					);
					if (this.auditionsDays != null && this.auditionsDays.length > 0) {
						this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day;
					}
				}
			});
		},
		pickaudition(audition) {
			if (audition.open) {
				if (this.pickedTimeSlot === audition) {
					this.pickedTimeSlot = {}
				}
				else {
					this.pickedTimeSlot = audition
				}
			}
		},
		moveToLogin() {
			if (Object.keys(this.pickedTimeSlot).length === 0 && this.pickedTimeSlot.constructor === Object) {
				return;
			}
			axios.post(APIbase+'/v2/deebs_audition',{
									hour: this.pickedTimeSlot.hour,
									day: this.pickedTimeSlot.day,
									site: this.site
								}).then(response => {
								console.log(response.data)
					this.userId = response.data.user_id;
					if (response.result === 'fail') {

					}
					else {
						this.showLogin = true;
					}
				})
		},
		nextDay() {
			if (this.pickedDay <  this.auditionsDays.length -1) {
				this.pickedDay += 1;
			}

			this.pickedTimeSlot = {}
			if (this.auditionsDays.length > 0) {
				this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day
			}
		},
		prevDay() {
			if (this.pickedDay > 0) {
				this.pickedDay -= 1;
			}
			this.pickedTimeSlot = {}
						if (this.auditionsDays.length > 0) {
			this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day
			}

		},
		chooseNorth() {
			if (this.site != "north") {
				this.pickedDay = 0;
				this.site = "north";
				if (this.totalAuditions[this.site] !== undefined) {
					this.auditionsDays = this.totalAuditions[this.site] || [{day:'',data:[]}]; // Ensure it's always an array
					if (this.auditionsDays.length > 0) {
						this.auditionsDaysComplete = this.auditionsDays.map(n => 
							n.data && n.data.some(c => c.open) ? false : true
						);
					}
					else {
						this.auditionsDaysComplete = true;
					}

					if (this.auditionsDays.length > 0 && this.auditionsDays[this.pickedDay]) {
						this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day;
					} else {
						this.auditionCurrentDate = "";
					}
				} else {
					this.auditionsDays = [{day:'',data:[]}];
					this.auditionsDaysComplete = true;
					this.auditionCurrentDate = "";
				}
			}
		},
		chooseCenter() {
			if (this.site != "center") {
				this.pickedDay = 0;
				this.site = "center";
				if (this.totalAuditions[this.site] !== undefined) {
					this.auditionsDays = this.totalAuditions[this.site] || [{day:'',data:[]}]; // Ensure it's always an array

					if (this.auditionsDays.length > 0) {
						this.auditionsDaysComplete = this.auditionsDays.map(n => 
							n.data && n.data.some(c => c.open) ? false : true
						);
					}
					else {
						this.auditionsDaysComplete = true;
					}

					if (this.auditionsDays.length > 0 && this.auditionsDays[this.pickedDay]) {
						this.auditionCurrentDate = this.auditionsDays[this.pickedDay].day;
					} else {
						this.auditionCurrentDate = "";
					}
				} else {
					this.auditionsDays = [{day:'',data:[]}];
					this.auditionsDaysComplete = true;
					this.auditionCurrentDate = "";
				}
			}
		}
	}

  }
</script>



// WEBPACK FOOTER //
// Audition.vue?43319ed1